import { FitnessCenter } from "@mui/icons-material";
import { FormSelectCompleted } from "@/components/form/FormSelectCompleted";
import { FormMultipleAutoComplete } from "@/components/form/FormMultipleAutoComplete";
import { useMedicalCareContext } from "@/contexts/MedicalCareContext";
import InputText from "@/components/form/InputText";
import { useState, useEffect } from "react";
import { useWatch } from "react-hook-form";
import {
    exerciseDaysPerWeekOptions,
    physicalActivityTypeOptions,
    physicalActivityIntensityOptions,
} from "../constants/options";
import { CollapsibleSection } from "./CollapsibleSection";

export function ExerciseFields() {
    const { control, setValue } = useMedicalCareContext();
    const [isOpen, setIsOpen] = useState(false);

    const exerciseDaysPerWeek = useWatch({
        control,
        name: "Anthropometric.exerciseDaysPerWeek",
        defaultValue: null,
    });

    const showExerciseDetails =
        exerciseDaysPerWeek &&
        exerciseDaysPerWeek.value !== "" &&
        exerciseDaysPerWeek.value !== "0";

    useEffect(() => {
        if (!showExerciseDetails) {
            setValue("Anthropometric.exerciseMinutesPerDay", "");
            setValue("Anthropometric.physicalActivityTypePhenX", []);
            setValue("Anthropometric.usualActivityIntensityPhenX", "");
        }
    }, [showExerciseDetails, setValue]);

    return (
        <CollapsibleSection
            title="Exercícios Físicos"
            icon={<FitnessCenter sx={{ fontSize: "24px", color: "primary.main" }} />}
            isOpen={isOpen}
            onToggle={() => setIsOpen(!isOpen)}
        >
            <FormSelectCompleted
                control={control}
                name="Anthropometric.exerciseDaysPerWeek"
                label="Dias por semana de exercício moderado a intenso"
                selectOptions={exerciseDaysPerWeekOptions}
            />
            {showExerciseDetails && (
                <>
                    <InputText
                        label="Minutos de exercício moderado a intenso nos dias exercitados"
                        name="Anthropometric.exerciseMinutesPerDay"
                        control={control}
                        type="number"
                    />
                    <FormMultipleAutoComplete
                        control={control}
                        name="Anthropometric.physicalActivityTypePhenX"
                        label="Tipo de atividade física"
                        selectOptions={physicalActivityTypeOptions}
                        defaultValue={[]}
                        variant="filled"
                    />
                    <FormSelectCompleted
                        control={control}
                        name="Anthropometric.usualActivityIntensityPhenX"
                        label="Intensidade usual da atividade"
                        selectOptions={physicalActivityIntensityOptions}
                    />
                </>
            )}
        </CollapsibleSection>
    );
}

